(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventListView",
                    {
                        url: "/EventList",
                        component: "eventListView",
                        PageTitle: "Event List | Marketing Tracker",
                        resolve: {
                            user: ["userApi", function (userApi) {
                                return userApi.getLoggedInUser().then(function (user) {
                                    return {
                                        UserId: user.Id,
                                        User: user
                                    };
                                });
                            }],
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }]
                        }
                    });
        }
    ]);

    app
        .component("eventListView",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventListView/event-list-view-template.html",
                controller: eventListViewController,
                bindings: {
                    user: "<",
                    onBehalfOfUser: "<"
                }
            });

    eventListViewController.$inject = ["marketingTrackerUserApi", "_", "marketingTrackerApi", "marketingTrackerAuthService", "userApi", "$filter", "$state", "marketingTrackerEventTypeApi", "marketingTrackerAgentApi", "marketingPlanApi", "figToaster"];
    function eventListViewController(marketingTrackerUserApi, _, marketingTrackerApi, marketingTrackerAuthService, userApi, $filter, $state, marketingTrackerEventTypeApi, marketingTrackerAgentApi, marketingPlanApi, figToaster) {
        var $ctrl = this;
        window.c = this;
        ng.extend($ctrl,
            {
                toggleSort: toggleSort,
                goToEvent: goToEvent,
                propertyName: 'EventDate',
                reverseOrder: false,
                onEventAdded: onEventAdded,
                intervals: [
                    {
                        Title: "Upcoming",
                        Filter: function (event) {
                            return filterByDateStatus(event, "Upcoming");
                        }
                    },
                    {
                        Title: "Past",
                        Filter: function (event) {
                            return filterByDateStatus(event, "Past");
                        }
                    },
                    {
                        Title: "All",
                        Filter: function (event) {
                            return true;
                        }
                    }
                ],
                initialDateFilters: [
                    {
                        Title: "Next 6 Months",
                        Filter: function (event) {
                            var now = new Date();
                            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                            var todayPlus6Months = new Date(now.getFullYear(), now.getMonth() + 6, now.getDate());
                            return event.EventDate >= today && event.EventDate <= todayPlus6Months;
                        }
                    },
                    {
                        Title: "Next 3 Months",
                        Filter: function (event) {
                            var now = new Date();
                            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                            var todayPlus3Months = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate());
                            return event.EventDate >= today && event.EventDate <= todayPlus3Months;
                        }
                    },
                    {
                        Title: "Next 60 Days",
                        Filter: function (event) {
                            var now = new Date();
                            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                            var todayPlus60Days = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 60);
                            return event.EventDate >= today && event.EventDate <= todayPlus60Days;
                        }
                    },
                    {
                        Title: "All",
                        Filter: function (event) { return true; }
                    },
                    {
                        Title: "Last 60 Days",
                        Filter: function (event) {
                            var now = new Date();
                            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                            var todayMinus60Days = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
                            return event.EventDate <= today && event.EventDate >= todayMinus60Days;
                        }
                    },
                    {
                        Title: "Last 3 Months",
                        Filter: function (event) {
                            var now = new Date();
                            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                            var todayMinus3Months = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
                            return event.EventDate <= today && event.EventDate >= todayMinus3Months;
                        }
                    },
                    {
                        Title: "Last 6 Months",
                        Filter: function (event) {
                            var now = new Date();
                            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                            var todayMinus6Months = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());
                            return event.EventDate <= today && event.EventDate >= todayMinus6Months;
                        }
                    }
                ],
                resultsPerPageOptions: [
                    { id: 1, count: 25 },
                    { id: 2, count: 50 },
                    { id: 3, count: 100 }],
                ui: {},
                loadingData: false
            });

        function filterByDateStatus(event, status) {
            var eventStatus = $filter('dateStatus')(event.EventDate);
            return eventStatus === status;
        }

        function onEventAdded(response) {
            var addedEvents;
            if (response instanceof Array) {
                var thing = _.map(response, _mapGroupsToEvents);
                var durp = _.flatten(thing);
                addedEvents = _.concat($ctrl.eventsList, durp);
            } else {
                addedEvents = _.concat($ctrl.eventsList, _mapGroupsToEvents(response));
            }
            _updateUiElements(addedEvents);
        }

        function goToEvent(event) {
            if (event.IsPlanning) {
                if (event.EventType.IsAncillary === true) {
                    return $state.go("Home.Tools.MarketingTrackerNew.Events.AncillaryPlanningEvent",
                        { "EventGroupId": event.AncillaryEventGroupId, "EventId": event.EventId });
                } else {
                    return $state.go("Home.Tools.MarketingTrackerNew.Events.PlanningEvent",
                        { "EventGroupId": event.EventGroupId, "EventId": event.EventId });
                }
            } else {
                if (event.EventType.IsAncillary === true) {
                    return $state.go("Home.Tools.MarketingTrackerNew.Events.AncillaryEvent",
                        { "EventGroupId": event.AncillaryEventGroupId, "EventId": event.EventId });
                } else {
                    return $state.go("Home.Tools.MarketingTrackerNew.Events.EventView", { "EventGroupId": event.EventGroupId, "EventId": event.EventId });
                }
            }
        }
        function _roundDate(timeStamp) {
            timeStamp -= timeStamp % (24 * 60 * 60 * 1000); //subtract amount of time (in ms) since midnight              
            timeStamp += new Date(timeStamp).getTimezoneOffset() * 60 * 1000; //add on the timezone offset         
            return new Date(timeStamp);
        }
        function _mapGroupsToEvents(group) {
            return _.map(group.Events,
                function (event) {
                    return _createEventsListItem(group, event);
                });
        }

        function _createEventsListItem(group, event) {
            return {
                EventName: !group.EventType.IsAncillary ? event.Title : group.EventType.Name,
                Venue: event.Location,
                EventDate: new Date(event.EventDate),
                EventId: event.Id,
                EventGroupId: !group.EventType.IsAncillary ? group.Id : null,
                AncillaryEventGroupId: group.EventType.IsAncillary ? group.Id : null,
                EventType: group.EventType,
                IsPlanning: event.IsPlanning
            };
        }

        function _getUpcomingEvents(events) {
            return $filter('upcomingEvents')(events);
        }

        function _calcEventCounts(eventsList, eventTypes) {
            var eventCounts = [];

            var thing = _.chain(eventsList)
                .filter({ IsPlanning: false })
                .uniqBy(function (row) {
                    if (row.EventGroupId !== null) {
                        return row.EventGroupId;
                    }
                    return row.AncillaryEventGroupId;
                })
                .groupBy('EventType.Name')
                .value();


            _.forEach(eventTypes, function (et) {
                eventCounts[et.Name] = thing[et.Name] ? thing[et.Name].length : 0;
            });

            return eventCounts;
        }

        function _createYearFilter(year) {
            return {
                Title: year,
                Filter: function (event) {
                    var eventDate = new Date(event.EventDate);
                    return eventDate.getFullYear() === year;
                }
            };
        }

        function _collectYears(years, event) {
            // Reducer function given a list of years, will see if an event's year is in that list and add it to it
            var eventDate = new Date(event.EventDate);
            var indexOfYear = _.findIndex(years, function (year) { return year === eventDate.getFullYear(); });
            if (indexOfYear === -1) {
                years.push(eventDate.getFullYear());
            }
            return years;
        }

        function _addYearsToDateRanges(events) {
            return $ctrl.initialDateFilters.concat(
                _.chain(events)
                    .reduce(_collectYears, [])
                    .map(_createYearFilter)
                    .value());
        }

        function _selectedUser() {
            if ($ctrl.onBehalfOfUser) {
                return {
                    UserId: $ctrl.onBehalfOfUser.Id,
                    User: $ctrl.onBehalfOfUser
                };
            }
            return $ctrl.user;
        }

        function _updateUiElements(events) {
            $ctrl.eventsList = _.orderBy(events, [$ctrl.propertyName], [$ctrl.reverseOrder]);
            $ctrl.eventCounts = _calcEventCounts(events, $ctrl.eventTypes);
            $ctrl.upcomingEventsList = !!events ? _getUpcomingEvents(events) : false;
            $ctrl.dateRanges = _addYearsToDateRanges($ctrl.eventsList);
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function _getEventsForFigAuthUserNextPage(figAuthUserId, nextPageToken) {
            return marketingTrackerUserApi.getUserAllEvents(nextPageToken)
                .then(function (events) {
                    if (!events.NextPage) return events;
                    return _getEventsForFigAuthUserNextPage(figAuthUserId, events.NextPage)
                        .then(function (recursiveEvents) {
                            return events = _.concat(events, recursiveEvents);
                        });
                });
        }

        function _getAllEventsForFigAuthUser(figAuthUser) {
            return _getEventsForFigAuthUserNextPage(figAuthUser.FigAuthUserId, null).then(function(events) {
                return _.map(events, function (event) {
                    event.EventDate = _roundDate(event.EventDate);
                    return event;
                });
            });
        }

        $ctrl.$onInit = function () {
            $ctrl.loadingData = true;
           
            $ctrl.dateRanges = $ctrl.initialDateFilters;
            $ctrl.ui.selectedDateRange = $ctrl.dateRanges[3];
            $ctrl.resultsPerPage = $ctrl.resultsPerPageOptions[1];

            marketingTrackerApi.getToken($ctrl.user.UserId)
                .then(function (token) {
                    marketingTrackerAuthService.setAccessToken(token);
                    marketingTrackerEventTypeApi.getEventTypesForUser(_selectedUser().UserId).then(function (types) {
                        $ctrl.eventTypes = types;
                        $ctrl.eventTypes.push({
                            Name: "FIG Event",
                            Id: "FIG Event"
                        });

                    });

                    marketingTrackerAgentApi.get().catch(ng.noop).then(function (agent) {
                        return marketingPlanApi
                            .getMarketingPlanByYear(agent.AgentId, (new Date).getFullYear()).then(function (plan) {
                                return $ctrl.recommendations = plan.Recommendations;
                            }, function () {
                                return $ctrl.recommendations = [];
                            });
                    });

                    return userApi.getFigAuth(_selectedUser().UserId);
                })
                .then(_getAllEventsForFigAuthUser)
                .then(_updateUiElements)
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem updating your data. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {

                   if ($ctrl.upcomingEventsList)
                        $ctrl.ui.selectedInterval = $ctrl.intervals[0];  //if upcoming
                    else  
                        $ctrl.ui.selectedInterval = $ctrl.intervals[2];  //else show all

                    $ctrl.loadingData = false;                   
                });
          
        };
    }

})(window.app, window.angular); //jshint ignore:line